import { Container, Row, Col, Section } from "react-bootstrap";
import React from "react";
import AACSBLogo from "../../Images/accrediations/aacsb.webp";
import NaacLogo from "../../Images/accrediations/Naac.webp";
import IAOULogo from "../../Images/accrediations/iaou.webp";
import unImage from "../../Images/home/unimage.webp";
import unStudentImage from "../../Images/home/unstudent.webp";
import "../../home2.css";

const AboutSec = () => {
  return (
    <React.Fragment>
      <section className="ptb-50">
        <div className="container-xxl pb-100">
          <Row className="g-4">
            {/* Card 1 (with border on small screens) */}
            <Col md={4} className="p-0">
              <a href="/naac-accreditation" target="_blank" className="info-card with-border text-decoration-none">
                <img src={NaacLogo} alt="NAAC" className="info-image" />
                <div className="info-content">
                  <h5>NAAC Accredited University</h5>
                  <p className="info-description">
                    Recognized by NAAC for academic excellence and quality
                    education in India.
                  </p>
                </div>
              </a>
            </Col>

            {/* Card 2 (with border on small screens) */}
            <Col md={4} className="p-0">
              <a href="/aacsb-accreditation" target="_blank" className="info-card with-border text-decoration-none">
                <img
                  src={AACSBLogo}
                  alt="Accreditation"
                  className="info-image"
                />
                <div className="info-content">
                  <h5>Member of AACSB Business Education Alliance</h5>
                  <p className="info-description">
                    Globally aligned with top business education standards and
                    innovation.
                  </p>
                </div>
              </a>
            </Col>

            {/* Card 3 (no border) */}
            <Col md={4} className="p-0">
              <a href="/iau-accreditation" target="_blank" className="info-card text-decoration-none">
                <img src={IAOULogo} alt="Curriculum" className="info-image" />
                <div className="info-content">
                  <h5>Member of International Association of Universities</h5>
                  <p className="info-description">
                    Part of global UNESCO network for student exchange &
                    collaboration.
                  </p>
                </div>
              </a>
            </Col>
          </Row>
        </div>
        <div className="container-xxl">
          <Row className="g-4">
            <Col md={6} className="about-images">
              <Row>
                {/* First image (Left) with larger top margin */}
                <Col md={6}>
                  <div
                    className="about-image-wrapper"
                    style={{ marginTop: "4rem" }}
                  >
                    <img
                      src={unImage}
                      alt="University Campus"
                      className="about-image img-fluid rounded-3 shadow"
                    />
                  </div>
                </Col>

                {/* Second image (Right) with larger bottom margin */}
                <Col md={6}>
                  <div
                    className="about-image-wrapper"
                    style={{ marginBottom: "3rem" }}
                  >
                    <img
                      src={unStudentImage}
                      alt="Students Learning"
                      className="about-image img-fluid rounded-3 shadow"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={6}>
              <div className="about-section">
                {/* Header */}
                <h3 className="modern-subtitle mb-3">
                  Explore What Makes Us Exceptional
                </h3>

                {/* Main Title */}
                <h2 className="modern-title mb-3">
                  {/* About Our University */}A Legacy of{" "}
                  <span>Excellence & Growth</span>
                </h2>

                {/* First Paragraph */}
                <p className="about-content first-content mb-3">
                  ISBM University endeavors to offer services across the
                  student-life cycle, supporting the students not only with
                  teaching-learning but also with career development, skill
                  enhancement, employment opportunities, business incubation,
                  fundraising and mentoring.
                </p>

                {/* Second Paragraph with more spacing */}
                <p className="about-content second-content mb-3">
                  ISBM University is established and approved by the Government
                  of Chhattisgarh under the Chhattisgarh Private Universities
                  (Establishment and Operation) Act, 2005 (Amendment Act 2016)
                  to confer doctorate, degree, diploma, and certificates to
                  students.
                </p>

                {/* Stats Cards Grid */}
                <Row className="g-4 mb-5">
                  <Col md={6}>
                    <a href="/about-placements" target="_blank" className="about-card shadow rounded p-3 h-100 d-flex flex-column text-decoration-none">
                      <div className="d-flex flex-grow-1">
                        <div className="card-icon me-3 mt-1">
                          <i className="ti ti-briefcase fs-1"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p className="card-text mb-0 text-purple fw-bold">
                            Startup Incubation and Placements
                          </p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn read-more-btn underline-wrapper p-0">
                          <span className="underline-content">
                            View More <i className="ti ti-arrow-right ms-2"></i>
                          </span>
                        </button>
                      </div>
                    </a>
                  </Col>

                  <Col md={6}>
                    <a href="/international-partnerships" target="_blank" className="about-card shadow rounded p-3 h-100 d-flex flex-column text-decoration-none">
                      <div className="d-flex flex-grow-1">
                        <div className="card-icon me-3 mt-1">
                          <i className="ti ti-globe fs-1"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p className="card-text mb-0 text-purple fw-bold">
                            International Academic Programmes
                          </p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn read-more-btn underline-wrapper p-0">
                          <span className="underline-content">
                            View More <i className="ti ti-arrow-right ms-2"></i>
                          </span>
                        </button>
                      </div>
                    </a>
                  </Col>

                  <Col md={6}>
                    <a href="/skill-development" target="_blank" className="about-card shadow rounded p-3 h-100 d-flex flex-column text-decoration-none">
                      <div className="d-flex flex-grow-1">
                        <div className="card-icon me-3 mt-1">
                          <i className="ti ti-shield fs-1"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p className="card-text mb-0 text-purple fw-bold">Skill Development</p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn read-more-btn underline-wrapper p-0">
                          <span className="underline-content">
                            View More <i className="ti ti-arrow-right ms-2"></i>
                          </span>
                        </button>
                      </div>
                    </a>
                  </Col>

                  <Col md={6}>
                    <a href="/career-counselling" target="_blank" className="about-card shadow rounded p-3 h-100 d-flex flex-column text-decoration-none">
                      <div className="d-flex flex-grow-1">
                        <div className="card-icon me-3 mt-1">
                          <i className="ti ti-school fs-1"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p className="card-text mb-0 text-purple fw-bold">
                            Career Readiness & Soft Skills Training
                          </p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn read-more-btn underline-wrapper p-0">
                          <span className="underline-content">
                            View More <i className="ti ti-arrow-right ms-2"></i>
                          </span>
                        </button>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        <div className="container-xxl">
          <Row className="g-4 justify-content-center">
            {/* Header Section - Centered */}
            <Col xs={12} className="text-center mb-5">
              <h6 className="modern-title mb-0">
                One of the{" "}
                <span className="main-header-content">
                  Top Private Universities
                </span>{" "}
                in Chhattisgarh
              </h6>
            </Col>

            {/* Stats Cards - Centered with max-width */}
            <div
              className="d-flex flex-wrap justify-content-center"
              style={{ maxWidth: "1200px", margin: "0 auto" }}
            >
              {/* Card 1 */}
              <Col md={3}>
                <div className="info-card-2 with-black-border h-100">
                  <div className="info-content-2 text-center">
                    <h6 className="task-info-title">17+</h6>
                    <p className="info-description-2">
                      Specialized Schools Offering a wide range of programs
                      tailored to your career aspirations
                    </p>
                  </div>
                </div>
              </Col>

              {/* Card 2 */}
              <Col md={3}>
                <div className="info-card-2 with-black-border h-100">
                  <div className="info-content-2 text-center">
                    <h6 className="task-info-title">200+</h6>
                    <p className="info-description-2">
                      Professionals Dedicated to empowering your academic and
                      career success
                    </p>
                  </div>
                </div>
              </Col>

              {/* Card 3 */}
              <Col md={3}>
                <div className="info-card-2 with-black-border h-100">
                  <div className="info-content-2 text-center">
                    <h6 className="task-info-title">5000+</h6>
                    <p className="info-description-2">
                      Applicants Trust ISBM University each year to shape their
                      Future
                    </p>
                  </div>
                </div>
              </Col>

              {/* Card 4 */}
              <Col md={3}>
                <div className="info-card-2 h-100">
                  <div className="info-content-2 text-center">
                    <h6 className="task-info-title">100+</h6>
                    <p className="info-description-2">
                      Leading Companies Actively recruiting Our talented
                      Graduates
                    </p>
                  </div>
                </div>
              </Col>
            </div>
          </Row>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AboutSec;
